import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { heroSlides } from "@/mocks/hero";
import { newsList } from "@/mocks/news";

export default function HeroSection() {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();
  const total = heroSlides.length;
  const active = heroSlides[index];

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % total);
    }, 6000);
    return () => window.clearInterval(timer);
  }, [total]);

  const goPrev = () => setIndex((prev) => (prev - 1 + total) % total);
  const goNext = () => setIndex((prev) => (prev + 1) % total);

  const latest = newsList.slice(0, 4);

  return (
    <section className="relative w-full bg-secondary-950 pb-12 pt-16 md:pb-16">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-6 px-4 pt-6 md:px-6 lg:grid-cols-3">
        <div className="relative col-span-1 overflow-hidden rounded-lg lg:col-span-2">
          <div className="relative h-[420px] w-full md:h-[560px]">
            <img
              key={active.id}
              src={active.image}
              alt={active.title}
              title={`${active.title} 蜜桃成熟时3D 焦点推荐`}
              className="h-full w-full object-cover object-top animate-fade-in"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/20 to-black/10"></div>

            <div className="absolute inset-x-0 bottom-0 p-5 md:p-8">
              <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
                {active.tag}
              </span>
              <h2 className="mb-3 font-heading text-2xl font-bold text-background-50 md:text-4xl">{active.title}</h2>
              <p className="mb-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
                {active.subtitle}
              </p>
              <div className="flex flex-wrap items-center gap-3">
                <button
                  type="button"
                  onClick={() => navigate(active.link)}
                  className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-play-fill w-4 h-4 flex items-center justify-center"></i>
                  查看详情
                </button>
                <Link
                  to="/news"
                  className="whitespace-nowrap rounded-md border border-background-50/50 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
                >
                  全部资讯
                </Link>
              </div>
            </div>

            <button
              type="button"
              onClick={goPrev}
              aria-label="上一张"
              className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/25 text-background-50 backdrop-blur transition-colors hover:bg-background-50/40 md:left-5 md:h-10 md:w-10"
            >
              <i className="ri-arrow-left-s-line w-5 h-5 flex items-center justify-center"></i>
            </button>
            <button
              type="button"
              onClick={goNext}
              aria-label="下一张"
              className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/25 text-background-50 backdrop-blur transition-colors hover:bg-background-50/40 md:right-5 md:h-10 md:w-10"
            >
              <i className="ri-arrow-right-s-line w-5 h-5 flex items-center justify-center"></i>
            </button>

            <div className="absolute bottom-5 right-5 hidden items-center gap-2 md:flex">
              {heroSlides.map((slide, i) => (
                <button
                  key={slide.id}
                  type="button"
                  aria-label={`切换到第 ${i + 1} 张`}
                  onClick={() => setIndex(i)}
                  className={`h-1.5 rounded-full transition-all ${
                    i === index ? "w-6 bg-primary-500" : "w-1.5 bg-background-50/60"
                  }`}
                ></button>
              ))}
            </div>
          </div>
        </div>

        <aside className="col-span-1 rounded-lg bg-background-50/95 p-5 backdrop-blur md:p-6">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <i className="ri-newspaper-line w-5 h-5 flex items-center justify-center text-primary-600"></i>
              最新快讯
            </h3>
            <Link to="/news" className="flex items-center gap-1 text-xs text-accent-600 hover:text-accent-700">
              更多
              <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
          <ul className="space-y-3">
            {latest.map((item) => (
              <li key={item.id}>
                <Link
                  to={`/detail/${item.id}`}
                  className="group flex gap-3 rounded-md p-1.5 transition-colors hover:bg-background-100"
                >
                  <span className="h-14 w-16 shrink-0 overflow-hidden rounded-md bg-background-100">
                    <img src={item.image} alt={item.title} className="h-full w-full object-cover object-top" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-900 group-hover:text-primary-700">
                      {item.title}
                    </span>
                    <span className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>
                      {item.date}
                    </span>
                  </span>
                </Link>
              </li>
            ))}
          </ul>
          <div className="mt-5 grid grid-cols-3 gap-2 border-t border-background-200 pt-4 text-center">
            <div>
              <p className="font-heading text-lg font-bold text-primary-700">3</p>
              <p className="text-[11px] text-foreground-500">章节速览</p>
            </div>
            <div>
              <p className="font-heading text-lg font-bold text-primary-700">8</p>
              <p className="text-[11px] text-foreground-500">主要演员</p>
            </div>
            <div>
              <p className="font-heading text-lg font-bold text-primary-700">3D</p>
              <p className="text-[11px] text-foreground-500">沉浸观看</p>
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}